import { useMemo, useState } from "react";
import {
  EndlinkMediaMap,
  MediaItem,
  SendCommunicationAttachmentResponse
} from "@coxauto-ui/cxm/communications/interfaces";
import { IEmailReplyContext } from "../context";

export function useEmailReplyState(): IEmailReplyContext {
  const [replyText, setReplyText] = useState("");
  const [replyTextSubject, setReplyTextSubject] = useState("");
  const [attachments, setAttachments] = useState<
    SendCommunicationAttachmentResponse[]
  >([]);
  const [selectedToChannelValue, setSelectedToChannelValue] = useState("");
  const [selectedStationeryHTML, setSelectedStationeryHTML] = useState<
    string | null
  >(null);
  const [templateHead, setTemplateHead] = useState<string | null>(null);
  const [selectedTemplateLoadState, setSelectedTemplateLoadState] = useState({
    hasLoaded: false,
    loadedTemplateId: null as string | null
  });
  const [ccRecipients, setCcRecipients] = useState<string[]>([]);
  const [bccRecipients, setBccRecipients] = useState<string[]>([]);
  const [showCcField, setShowCcField] = useState(false);
  const [showBccField, setShowBccField] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState<MediaItem[]>([]);
  const [endlinkMediaMap, setEndlinkMediaMap] = useState<EndlinkMediaMap>({});

  return useMemo(
    () => ({
      replyText,
      replyTextSubject,
      attachments,
      selectedToChannelValue,
      selectedStationeryHTML,
      templateHead,
      selectedTemplateLoadState,
      ccRecipients,
      bccRecipients,
      showCcField,
      showBccField,
      selectedMedia,
      endlinkMediaMap,
      setReplyText,
      setReplyTextSubject,
      setAttachments,
      setSelectedToChannelValue,
      setSelectedStationeryHTML,
      setTemplateHead,
      setSelectedTemplateLoadState,
      setCcRecipients,
      setBccRecipients,
      setShowCcField,
      setShowBccField,
      setSelectedMedia,
      setEndlinkMediaMap
    }),
    [
      replyText,
      replyTextSubject,
      attachments,
      selectedToChannelValue,
      selectedStationeryHTML,
      templateHead,
      selectedTemplateLoadState,
      ccRecipients,
      bccRecipients,
      showCcField,
      showBccField,
      selectedMedia,
      endlinkMediaMap
    ]
  );
}
